import { Injectable } from '@angular/core';

import { importKey } from '../../shared/utilities/import-key.utility';
import { EncryptionConfigService } from './encryption-config.service';
import { WebCryptoService } from './web-crypto.service';

@Injectable({
    providedIn: 'root'
})
export class EncryptionKeyService {
    private _keyPromise: Promise<CryptoKey>;

    constructor(
        private readonly webCryptoService: WebCryptoService,
        private readonly encryptionConfigService: EncryptionConfigService
    ) {
    }

    public get key(): Promise<CryptoKey> {
        if (!this._keyPromise) {
            this._keyPromise = this.importKey();
        }

        return this._keyPromise;
    }

    private async importKey(): Promise<CryptoKey> {
        return importKey(this.encryptionConfigService.config.cryptoKey, this.webCryptoService.crypto.subtle);
    }
}
